module.exports = __webpack_public_path__ + "img/yishi4.caf048eb.jpg";